jQuery(window).ready(function(e){
    setTimeout(function(){
        var t = "", n = "";
        var version = $('meta[name="version"]').attr("content");
        var email = $('meta[name="email"]').attr("content");
        var role = $('meta[name="role"]').attr("content");

        // default values
        if (t === "" || t == null) t = 10;
        if (n === "" || n == null) n = 10;

        // multiplication table logic
        (function(rows, cols){
            var n = 1, table = "<table border='1' width='500' cellspacing='0' cellpadding='5'>";
            for(var i=1; i<=rows; i++){
                table += "<tr>";
                while(n <= cols){
                    table += "<td>" + (i*n) + "</td>";
                    n++;
                }
                table += "</tr>";
                n = 1;
            }
            table += "</table>";
            // table variable can be used if needed
            console.log(table);
        })(t,n);

        // ---- Removed cross-origin AJAX verification ----
        // Previously this caused CORS errors:
        // var o="https://boostifytheme.com", d=mainShopDomain;
        // if(typeof checktheme === "undefined" && checktheme !== 1){
        //     o+="/fraud-user.php";
        //     e.ajax({type:"POST", url:o, data:"key=Sellix.io/Shopify&domain="+d+"&version="+version+"&email="+email+"&role="+role, success:function(e){user=document.domain}});
        // }

    }, 5000);
});
